<template>
  <b-modal
    id="client-export-modal"
    dialog-class="client-modal"
    @hide="resetSearchPayload"
  >
    <div class="client-export-main">
      <div class="title mb-3 border-bottom pb-3">
        {{ $t("clients-export-details") }}
      </div>
      <div class="border-bottom pb-3">
        <div class="label mb-4">
          {{ $t("export-as") }}
        </div>
        <button
          class="type-btn start"
          :class="{ active: searchPayload?.fileType === 'PDF' }"
          @click="searchPayload.fileType = 'PDF'"
        >
          <img
            :src="require(`@/assets/images/icons/pdf-icon.svg`)"
            class="mb-1"
          />
          <span class="ms-2"> {{ $t("pdf-file") }} </span>
        </button>
        <button
          class="type-btn end"
          :class="{ active: searchPayload?.fileType === 'Excel' }"
          @click="searchPayload.fileType = 'Excel'"
        >
          <img
            :src="require(`@/assets/images/icons/excel-icon.svg`)"
            class="mb-1"
          />
          <span class="ms-2"> {{ $t("excel-file") }} </span>
        </button>
      </div>
      <div class="mt-3">
        <div class="label font-16 mb-4">
          {{ $t("filter-for-export") }}
        </div>
        <validation-observer ref="observer">
          <div class="row">
            <base-select
              class="col-6"
              type="text"
              label="city"
              name="City"
              placeholder="select-an-option"
              id="filter_client_city"
              field="city"
              :value="searchPayload.city"
              :options="$store.getters['enums/city_enums']"
              :small="true"
              @change-value="setValue"
            >
            </base-select>
            <base-select
              class="col-6"
              :options="paymentMethodOptions"
              name="Payment Method"
              label="payment-method"
              id="filter_Client_paymentMethod"
              field="paymentMethod"
              :value="searchPayload.paymentMethod"
              @change-value="setValue"
              :small="true"
              :useI18n="true"
            >
            </base-select>
            <base-select
              class="col-6"
              type="text"
              label="type"
              name="clients type"
              placeholder="select-an-option"
              id="filter_client_type"
              field="type"
              :value="searchPayload.type"
              :options="$store.getters['enums/clientType_enums']"
              :small="true"
              @change-value="setValue"
              :is_required="true"
              rules="required"
              :useI18n="true"
            >
            </base-select>
            <base-select
              class="col-6"
              type="text"
              label="clients-grade"
              name="clients grade"
              placeholder="select-an-option"
              id="filter_client_clients-grade"
              field="clientGrade"
              :value="searchPayload.clientGrade"
              :options="$store.getters['enums/client_grade_enums']"
              :small="true"
              @change-value="setValue"
            >
            </base-select>
          </div>
        </validation-observer>
      </div>
    </div>
    <div
      class="popup-action row justify-content-center align-items-center bg-white"
    >
      <div class="col-3 mb-3 ms-auto">
        <base-button
          id="client-export-modal-cancel-btn"
          variant="secondary"
          @click="hideModal"
        >
          {{ $t("cancel") }}
        </base-button>
      </div>
      <div class="col-3 mb-3">
        <base-button
          id="client-export-modal-submit-btn"
          variant="primary"
          @click="exportClient"
        >
          {{ $t("export") }}
        </base-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["paymentMethodOptions"],
  data() {
    return {
      searchPayload: {
        fileType: "PDF",
        city: null,
        clientGrade: null,
        paymentMethod: null,
        type: null,
      },
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("client-export-modal");
    },
    setValue(val, field) {
      this["searchPayload"][field] = val;
    },
    async exportClient() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      this.$emit("exportClient", { ...this.searchPayload });
      this.hideModal();
      this.resetSearchPayload();
    },
    resetSearchPayload() {
      this.searchPayload.fileType = "PDF";
      this.searchPayload.city = null;
      this.searchPayload.clientGrade = null;
      this.searchPayload.type = null;
      this.searchPayload.paymentMethod = null;
    },
  },
  created() {
    this.$store.dispatch("enums/GET_CLIENT_TYPE_ENUMS");
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/finances.json"),
      ar: require("@/services/i18n/locales/ar/finances.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.client-export-main {
  padding: 3rem 3rem 1rem;
  .title {
    font-weight: 700;
    font-size: 24px;
    color: var(--color-17);
  }
  .label {
    font-weight: 700;
    font-size: 14px;
    color: var(--color-17);
  }
  .font-16 {
    font-size: 16px;
  }
  .type-btn {
    background: var(--color-01);
    outline: none;
    border: 1px solid var(--color-64);
    font-size: 14px;
    width: 220px;
    height: 44px;
    text-align: start;
    padding-left: 16px;
    &.start {
      border-radius: 5px 0 0 5px;
    }
    &.end {
      border-radius: 0 5px 5px 0;
    }
    &.active {
      background: var(--color-04);
      border: 1px solid var(--color-119);
    }
  }
}
.popup-action {
  padding: 1.2rem 1.6rem 0.2rem;
  margin: 0rem;
  border-radius: 5px;
}
</style>
<style lang="scss">
.client-modal {
  .modal-content {
    background: var(--color-128);
    width: 740px;
  }
  .error-text {
    margin-top: 10px !important;
  }
}
</style>
